// extracted by mini-css-extract-plugin
module.exports = {"ExpandOrApply__buttons":"ExpandOrApply_ExpandOrApply__buttons__vtC5A"};